import { api } from './index';
import type { ClinicalAuthor } from '../utils/clinical-author';
import type { ClinicalVoidable } from '../utils/clinical-void';

const BASE_PATH = '/api/internal/task_records';

export type TaskRecord = ClinicalVoidable & {
  id: number;
  humanScheduledAt: string;
  humanRecordedAt?: string;
  aasmState: 'pending' | 'completed' | 'incomplete';
  observations?: string;
  taskName: string;
  taskCategoryName: string;
  caregiverFullName: string | null;
  edited: boolean;
  author: ClinicalAuthor | null;
}

// What bringing a shift's tasks in line with the patient's task plan changes;
// only a shift in progress can be brought in line.
export type TaskPlanSync = {
  inProgress: boolean;
  toCreate: number;
  toRemove: number;
}

export const taskRecordsApi = {
  indexByShift(shiftId: number): Promise<TaskRecord[]> {
    return api({
      method: 'get',
      url: `${BASE_PATH}?shift_id=${shiftId}`,
    }).then(response => response.data.taskRecords);
  },

  planSync(shiftId: number): Promise<TaskPlanSync> {
    return api({
      method: 'get',
      url: `/api/internal/shifts/${shiftId}/task_plan_sync`,
    }).then(response => response.data.taskPlanSync);
  },

  syncPlan(shiftId: number): Promise<TaskPlanSync> {
    return api({
      method: 'post',
      url: `/api/internal/shifts/${shiftId}/task_plan_sync`,
    }).then(response => response.data.taskPlanSync);
  },
};
